import { render, staticRenderFns } from "./FacilityListManagement.vue?vue&type=template&id=24a774b8&scoped=true"
import script from "./FacilityListManagement.vue?vue&type=script&lang=js"
export * from "./FacilityListManagement.vue?vue&type=script&lang=js"
import style0 from "./FacilityListManagement.vue?vue&type=style&index=0&id=24a774b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a774b8",
  null
  
)

export default component.exports